import { Form } from "@circle-react-uikit/Form";
import { useFormItem } from "../../DefaultEditorV2/useFormItem";

export interface NumberFieldProps {
  label: string;
  max?: number;
  min?: number;
  name: string;
  step?: number;
}

export const NumberField = ({ name, label, ...rest }: NumberFieldProps) => {
  const { getFormItemProps } = useFormItem();

  return (
    <Form.Item name={name} label={label} {...getFormItemProps()}>
      <Form.Input type="number" name={name} {...rest} />
    </Form.Item>
  );
};
